import React, { Component } from 'react';

import FieldLabel from 'components/FieldLabel';

export default class FieldTextarea extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value || '',
            populated: false,
            focus: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleChange(event) {
        const value = event.target.value;

        this.setState({
            value: value.slice(0, this.props.max || Infinity),
            populated: value !== ''
        });

        this.props.onChange && this.props.onChange(value);
     }

    handleFocus() {
        this.setState({
            focus: true
        });
    }

    handleBlur() {
        this.setState({
            focus: false
        });
    }

    get labelElement() {
        if (this.props.label) {
            return (
                <FieldLabel id={this.props.id} required={this.props.required} dark={this.props.darkLabel}>{ this.props.label }</FieldLabel>
            );
        } else {
            return null;
        }
    }

    get maxLength() {
        if (this.props.max) {
            return (
                <span className="field-max-length">
                    {(this.state.value || '').length}/{this.props.max}
                </span>
            );
        } else {
            return null;
        }
    }

    componentWillReceiveProps(props) {
        this.setState({
            value: props.value,
            populated: props.value !== ''
        });
    }

    render() {
        return (
            <div className="field-holder">
                { this.labelElement }

                <div className={'field field-default' + (this.state.populated ? ' populated' : '') + (this.state.focus ? ' focus' : '')}>
                    {this.maxLength}

                    {this.props.children}

                    <textarea onFocus={this.handleFocus} onBlur={this.handleBlur} max={this.props.max} onChange={this.handleChange} className="field-input" id={this.props.id} placeholder={this.props.placeholder} value={this.state.value}></textarea>
                </div>
            </div>
        );
    }
}
